<template>
	<div class="h-screen w-full">
		<NewUser v-if="!roles.length" />
		<HoverPopper v-if="roles.length" />
		<CommandPalette />
		<div class="flex h-full flex-col" :class="{ 'flex-col': !fullscreen }">
			<top-nav v-if="!fullscreen" :sidebar-open="sidebarOpen" class="z-10 w-full" />

			<div class="flex flex-1" :class="{ 'flex-row': !fullscreen }">
				<side-nav
					v-if="!fullscreen"
					:sidebar-open="sidebarOpen"
					class="invisible h-full overflow-y-auto border-r border-gray-200 dark:border-gray-700 sm:visible"
				/>

				<div
					class="flex flex-1 flex-col transition-all"
					:class="{ 'sm:pl-[220px]': sidebarOpen, 'sm:pl-[80px]': !sidebarOpen, 'pt-[70px]': !fullscreen }"
				>
					<main class="flex-1">
						<router-view v-if="mounted"></router-view>
					</main>
					<Footer v-if="!fullscreen" />
				</div>
			</div>
		</div>

		<transition name="expand">
			<div v-if="showContactFormModal">
				<contact-modal :contact="modalProp1" />
			</div>
		</transition>
	</div>
</template>

<script>
import { computed } from 'vue'
import tenantsApi from './scripts/tenants/tenants.api'
import NewUser from './components/NewUser.vue'
import HoverPopper from './components/HoverPopper.vue'
import accountsApi from './scripts/accounts/accounts.api'
import Footer from './components/Footer.vue'
import CommandPalette from './components/common/CommandPalette.vue'
import globalEventBus from './globalEventBus'
import axios from 'axios'

export default {
	components: {
		NewUser,
		Footer,
		HoverPopper,
		CommandPalette
	},
	provide() {
		return {
			showContactFormModal: computed({
				get: () => this.showContactFormModal,
				set: (value) => (this.showContactFormModal = value)
			}),
			modalProp1: computed({
				get: () => this.modalProp1,
				set: (value) => (this.modalProp1 = value)
			}),
			modalProp2: computed({
				get: () => this.modalProp2,
				set: (value) => (this.modalProp2 = value)
			}),
			user: this.$auth0.user,
			tenants: computed({
				get: () => this.tenants
			}),
			userRoles: computed(() => this.roles),
			userAccounts: computed(() => this.userAccounts),
			sidebarOpen: computed({
				get: () => this.sidebarOpen,

				set: (value) => (this.sidebarOpen = value)
			}),
			fullscreen: computed({
				get: () => this.fullscreen,
				set: (value) => (this.fullscreen = value)
			}),
			nwError: computed(() => this.networkErrorInProgress)
		}
	},
	data() {
		return {
			roles: ['temp'],
			tenants: [],
			showContactFormModal: false,
			modalProp1: null,
			modalProp2: null,
			mounted: false,
			fullscreen: false,
			sidebarOpen: localStorage.getItem('sidebarOpen') ? localStorage.getItem('sidebarOpen') === 'true' : true,
			networkErrorInProgress: false,
			isMobileDevice: false,
			lastNetworkErrorTime: 0
		}
	},
	async mounted() {
		try {
			this.isMobileDevice = this.$global.isMobile

			const token = await this.$auth0.getAccessTokenSilently()

			if (token) {
				const roles = this.parseJwt(token).permissions
				this.roles = roles

				if (roles.includes('account')) {
					this.tenants = []
					this.userAccounts = (await accountsApi.getAll({ limit: 2500 })).data.results.sort((a, b) =>
						a.name.toLowerCase().localeCompare(b.name.toLowerCase())
					)

					if (window.location.pathname === '/dashboard') {
						this.$router.replace('/calls')
					}
				} else {
					const result = await tenantsApi.getAll()
					this.tenants = result.data.results.sort((a, b) =>
						a.companyName.toLowerCase().localeCompare(b.companyName.toLowerCase())
					)
				}

				if (
					this.tenants.length < 2 ||
					(parseInt(this.$global.getSelectedTenant()) &&
						!this.tenants.find((t) => t.id === parseInt(this.$global.getSelectedTenant())))
				) {
					this.$global.clearSelectedTenant()
				}

				this.mounted = true
			}
		} catch (error) {
			this.mounted = true
			console.log(error)
		}

		const browserName = navigator.userAgent
		const match = browserName.match(/(chrome|firefox|opera|safari|msie|edge)\/?\s*(\.?\d+(\.\d+)*)/i)
		const browser = match ? match[1] : 'Other'
		const version = match ? match[2] : '0'
		window.umami.track(browser + ' ' + version)

		const testApiReadiness = async () => {
			try {
				const response = await axios.get(window.dtServerUrl + '/health', { timeout: 2000 })
				if (response?.data === 'OK') {
					this.networkErrorInProgress = false

					const shouldReload = !this.isMobileDevice || Date.now() - this.lastNetworkErrorTime > 5000
					if (shouldReload) {
						window.location.reload()
					}
				} else {
					setTimeout(testApiReadiness, 2500)
				}
			} catch (error) {
				setTimeout(testApiReadiness, 2500)
			}
		}

		globalEventBus.on('network-error', (error) => {
			if (!this.networkErrorInProgress) {
				this.networkErrorInProgress = true
				this.lastNetworkErrorTime = Date.now()

				if (!this.isMobileDevice) {
					!this.nwError &&
						this.$swal({
							title: 'Network error',
							icon: 'error',
							text: 'Unable to reach TeleFlow. Please check your broadband connection and try again. Alternatively contact support to check for any known isuses.',
							allowOutsideClick: false,
							showConfirmButton: false
						})
				}

				const timeout = 5000
				setTimeout(testApiReadiness, timeout)
			}
		})
	},
	methods: {
		parseJwt(token) {
			var base64Url = token.split('.')[1]
			var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
			var jsonPayload = decodeURIComponent(
				window
					.atob(base64)
					.split('')
					.map(function (c) {
						return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
					})
					.join('')
			)

			return JSON.parse(jsonPayload)
		}
	}
}
</script>
